import { createContext, RefObject, useContext } from "react";

export interface NavScroll {
  containerRef: RefObject<HTMLElement>;
  /**
   * Animates the nav to `targetTop`, abandoning any scroll already in flight so
   * that two categories expanded in quick succession can't fight over the
   * container frame by frame.
   */
  scrollTo: (targetTop: number) => void;
}

const NavScrollContext = createContext<NavScroll | null>(null);

export const NavScrollProvider = NavScrollContext.Provider;

/** Null outside the nav, e.g. when a NavItem renders inside the collapsed flyout. */
export function useNavScroll() {
  return useContext(NavScrollContext);
}
